// @ts-nocheck
import {
    chain,
    SetUpProductInfos as baseSetUpProductInfos,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { createFromProduct } from "@store/Modules/client-framework/src/Common/ProductInfo";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetUpProductInfos = createChainHandler("SetUpProductInfos", chain, props => {
    // Only the "createFromProduct" function import has changed.
    const categoryPath = props.apiParameter.search ? undefined : props.result.catalogPage?.canonicalPath;

    props.idByPath = {};

    props.result.products?.forEach(product => {
        if (props.result.productInfosByProductId[product.id]) {
            return;
        }

        const productDetailPath = categoryPath ? `${categoryPath}/${product.urlSegment}` : product.canonicalUrl;
        props.idByPath![productDetailPath] = product.id;
        props.result.productInfosByProductId[product.id] = {
            ...createFromProduct(product),
            productDetailPath,
        };
    });
});

replaceInChain(chain, baseSetUpProductInfos, SetUpProductInfos);
